

import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import LogoutIcon from "../../Common/svg/logouticon";


const LogOutModal = ({ isModalOpen, handleLogout, isLoading, closeModal }) => {
 

  return (
    <Modal isOpen={isModalOpen} centered className="rounded-3">
        <ModalBody>
          <div className="text-center">
              <div className="icon-wrapper red">
       <LogoutIcon/>
              </div>
            <h5 className="font20 font700"> تسجيل الخروج</h5>
       
          </div>
        </ModalBody>
   <div className="p-3">
      <div className="row">
        
        <div className="col-md-6">
          <button  
            className="btn btn-white w-100 "
            disabled={isLoading}
            onClick={closeModal}
          >
            إلغاء
          </button>
        </div>
        <div className="col-md-6">
          <button
            className="btn btn-outline-danger w-100"
            disabled={isLoading}
            onClick={handleLogout}
          >  
     
            {isLoading ? <Spinner size="sm"/> : " تسجيل الخروج"}
          </button>
        </div>
      </div>

   </div>

    </Modal>
  );
};

export default LogOutModal;
